export enum ACHIEVEMENT_TYPE {
  FAVOURITE_SPORT = 'FAVOURITE_SPORT',
  FAVOURITE_CASINO_GAME = 'FAVOURITE_CASINO_GAME',
  BIGGEST_CASINO_WIN = 'BIGGEST_CASINO_WIN',
  FIRST_CASINO_WIN = 'FIRST_CASINO_WIN',
  FIRST_SPORTSBOOK_WIN = 'FIRST_SPORTSBOOK_WIN',
  MOST_RECENT_SPORTSBOOK_WIN = 'MOST_RECENT_SPORTSBOOK_WIN',
  BIGGEST_SPORTSBOOK_WIN = 'BIGGEST_SPORTSBOOK_WIN',
  BIGGEST_SUPERCHARGE = 'BIGGEST_SUPERCHARGE',
  BEST_CASHOUT = 'BEST_CASHOUT',
}
